import { render } from "./AvertissementEcran.vue?vue&type=template&id=b74de810&ts=true"
import script from "./AvertissementEcran.vue?vue&type=script&lang=ts"
export * from "./AvertissementEcran.vue?vue&type=script&lang=ts"

import exportComponent from "/workspaces/theokoel.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__